"use client";

import { useCallback, useSyncExternalStore } from "react";

// useSyncExternalStore renders `serverMatch` during SSR and hydration, then
// re-renders with the real match, so there is no hydration mismatch.
export function useMediaQuery(query: string, serverMatch = false): boolean {
	const subscribe = useCallback(
		(onChange: () => void) => {
			const list = window.matchMedia(query);
			list.addEventListener("change", onChange);
			return () => list.removeEventListener("change", onChange);
		},
		[query]
	);

	return useSyncExternalStore(
		subscribe,
		() => window.matchMedia(query).matches,
		() => serverMatch
	);
}
